<template>
    <div class="popup popup--mini" @mousedown.self="$emit('close')">
        <div class="popup__block">
            <div class="popup__top">
                <div class="popup__title">Запустить переторжку</div>
                <div class="popup__close" @click="$emit('close')"></div> 
            </div>
            <div class="popup__content">
                <div class="popup__form">
                    <InputDate v-model="endTime" :label="'Укажите дату окончания нового этапа'" :placeholder="'xx.xx.xxxx 00:00'" :mode="'dateTime'" :errors="v$.formData.date.$errors" />
                </div>
                <div class="popup__btns">
                    <button class="btn btn--color" @click="handleSubmit">Запустить</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {mapActions} from "vuex";
import {useToast} from "vue-toastification";
import InputDate from "@/components/base/utils/formElements/InputDate.vue";
import useVuelidate from "@vuelidate/core";
import {required, helpers} from '@vuelidate/validators'
const {withMessage} = helpers

export default {
    name: 'RebiddingTenderPopup',
    emits: ['close', 'updateTender'],
    components: { InputDate },
    props: {
        tenderId: {
            type: Number,
            required: true
        }
    },
    setup() {
		return {
            toast: useToast(),
			v$: useVuelidate()
		}
	},
    data() {
        return {
            endTime: [''],
            formData: {
                id: this.tenderId,
                date: '',
            }
        }
    },
    watch: {
		endTime: {
			handler(newValue) {
				this.formData.date = this.getLocaleDateAndTime(newValue[0]);
			},
			deep: true
		},
    },
    methods: {
        getLocaleDateAndTime(value,needTime = true) {
			const date = new Date(value).toLocaleDateString();
			const time = needTime ? new Date(value).toLocaleTimeString().slice(0,5) : '';
			if(time) {
				return `${date} ${time}`
			}
			return date
		},
        async handleSubmit() {
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				return
			}

            const res = await this.rebiddingTender(this.formData);
            if (res.success) {
                this.toast.success(`Новый этап успешно запущен`);
            }

            this.$emit('updateTender');
            this.$emit('close');
        },
        ...mapActions({
            rebiddingTender: 'tenders/rebiddingTender',
        })
    },
	validations() {
		return {
			formData: {
				date: {
					required: withMessage("Заполните дату окончания", required),
				},
			}
		}
	},
}
</script>
